<template>
  <div id="hist">
    <el-container>
      <el-header><i class="fas fa-clipboard-list fa-fw"></i> 発注管理（反響管理）</el-header>
      <el-main>
      <el-alert :title="message.msg" type="error" v-if="message.err"></el-alert>
      <el-card class="box-card">
        <template #header>
          <div class="card-header" style="color:#606266;display: flex;justify-content: space-around;align-items: center;">
          <span>発注番号 {{ order_info['order_id'] }}</span>
          <el-divider direction="vertical"></el-divider>
          <span>{{ order_info['dweek'] }}</span>
          <span>{{ distribute_way[order_info['segment']] }}配布</span>
          <el-divider direction="vertical"></el-divider>
          <span>{{ order_info['size'] }}</span>
          <el-divider direction="vertical"></el-divider>
          <span>{{ Number(order_info['order_qty']).toLocaleString() }}部</span>
          <el-divider direction="vertical"></el-divider>
          <span>金額 {{ Number(order_info['order_price']).toLocaleString() }}円（税別）</span>
          <el-divider direction="vertical"></el-divider>
          <span>発注日 {{ order_info['order_date'] }}</span>
          <el-tooltip class="item" effect="dark" content="チラシ画像アップロード" placement="top">
            <el-button type="primary" size="mini" icon="el-icon-upload" circle @click="uplDialog"></el-button>
          </el-tooltip>
          <div class="demo-image__preview" style="display: inline-flex;">
            <el-image 
              style="width: 30px; height: 30px"
              :src="url" 
              :preview-src-list="srcList">
              <template #error>
                <div class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </template>
            </el-image>
          </div>
          </div>
        </template>
        <hist-area-tbl :arealist="area_list" :loading="loading"></hist-area-tbl>
      </el-card>
      </el-main>
      <el-footer>
        <el-button type="success" @click="updFeedback">更新</el-button>
        <el-button type="info" @click="back">戻る</el-button>
      </el-footer>
    </el-container>
    <el-dialog
      title="画像アップロード"
      v-model="dialogVisible"
      width="345px">
      <p>2画像（表裏）までアップロードできます。</p>
      <ul class="el-upload-list el-upload-list--picture-card" style="display: inline-flex">
        <li class="el-upload-list__item is-success" v-for="(img, idx) in srcList" :key="idx" v-on:mouseover="handleImgHover(idx)" v-on:mouseleave="handleImgLeave(idx)">
        <el-image
          style="width: 148px; height: 148px"
          :src="img"
          fit="cover">
        </el-image>
        <span class="overray" v-show="imgHover[idx]" @click="handleDelete(img)">
          <i class="el-icon-delete"></i>
        </span>
        </li>
        <li v-show="srcList.length < 2" class="el-upload-list__item is-success">
        <el-upload
          class="avatar-uploader"
          :action="uploader"
          :data="imgOptions"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
          :on-success="handleAvatarSuccess">
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        </li>
      </ul>
      <el-alert
          title="※ 4MB以下のJPG、PNG、または、PDF形式"
          type="info"
        :closable="false">
      </el-alert>
    </el-dialog>
    <el-dialog
      title="削除確認"
      v-model="isShowConf"
      width="30%">
      <span>{{ delImg.msg }}を削除していいですか？</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="isShowConf = false">いいえ</el-button>
          <el-button type="primary" @click="deleteImage">はい</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import HistAreaTbl from '@/components/HistAreaTbl.vue';
import { clsUser } from '@/types/clsUser';
import { app } from '../main';
import { distribute_way } from '../BizTerms';

interface area_row {
  area_id: string;
  key_code: string;
  town: string;
  order_qty: number;
  resval: number;
  get_order_qty: number;
  get_order_mnt: number;
  rescom: string;
}

export default defineComponent({
  components: { HistAreaTbl },
  props: ['user'],
  setup(props, context) {
    const router = useRouter()
    if(!props.user.login) {
      console.log('Can\'t access OrderDetail for not login.')
      router.push('/login')
    }
    const route = useRoute()
    const loading = ref(false)
    const dialogVisible = ref(false)
    const isShowConf = ref(false)
    const message = reactive({
      msg: '',
      err: false,
      clear() {
        this.msg = ''
        this.err = false
      },
    })
    const api_path = app.config.globalProperties.api_path
    const order_info = reactive({
      order_id: '',
      segment: '',
      size: '',
      order_qty: 0,
      order_price: 0,
      order_date: ''
    })
    const area_list: area_row[] = reactive([])
    const srcList:any = reactive([])
    const delImg = reactive({
      path: '',
      msg: ''
    })
    const imgOptions = reactive({
      order_id: '',
      file_name: ''
    })
    const url = ref('')
    const uploader = api_path + 'ajax/upload.php'
    const uplDialog = () => {
      dialogVisible.value = true
    }
    const beforeAvatarUpload = (file: any) => {
      const mime = [
      "image/jpeg",
      "image/png",
      "application/pdf"
      ]
      const isMIME = mime.includes(file.type)
      const isLt4M = file.size / 1024 / 1024 < 4

      if (!isMIME) {
        app.config.globalProperties.$message.error('アップロードできる画像はJPG、PNGまたはPDFです。')
      }
      if (!isLt4M) {
        app.config.globalProperties.$message.error('画像が4MBを超えています。')
      }
      return isMIME && isLt4M
    }
    const imgHover = reactive([false])
    const handleImgHover = (idx: number) => {
      imgHover[idx] = true
    }
    const handleImgLeave = (idx: number) => {
      imgHover[idx] = false
    }
    const handleAvatarSuccess = (res: string, file: any) => {
      if(res == 'success') {
        app.config.globalProperties.$message({
          message: `${file.name} uploaded successfully`,
            type: 'success'
          });
        getFiles()
      }
    }
    const handleDelete = (img: any) => {
      let msg = [], conv:{[SideA:string]: string} = { SideA: '表', SideB: '裏' }
      delImg.path = img.replace(/\?.*$/,"")
      msg = delImg.path.split('/')
      delImg.msg = `発注番号${msg[2]}の${conv[msg[3].split('.')[0]]}面画像`
      isShowConf.value = true
    }
    const back = () => {
      router.push('/hist')
    }
    const updFeedback = () => {
      let feedback:any = [], memo = '', totalRes = 0
      // 反響数入力エリアのみ抽出
      area_list.some((row: area_row) => {
        if(row.resval + row.get_order_qty + row.get_order_mnt > 0) {
          totalRes += row.resval + row.get_order_qty
          if('rescom' in row) {
            memo = row.rescom
          }else {
            memo = ''
          }
          feedback.push({ 
            area_id: row.area_id, 
            order_id: order_info['order_id'], 
            inquiry_qty: row.resval, 
            get_order_qty: row.get_order_qty, 
            get_order_mnt: row.get_order_mnt, 
            memo: memo 
          })
        }
      })
      //console.log(totalRes, feedback)
      const json = { 
        order_id: order_info['order_id'],
        total: totalRes,
        list: feedback,
        csrf: props.user.csrf
      }
      fetch(api_path + 'ajax/add_feedback.php', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(json)
      })
      .then(response => response.json())
      .then(json => {
        if(json['result'] == 'failure') {
          message.msg = json['error'];
          message.err = true;
          app.config.globalProperties.$message.error('更新できませんでした。.');
        }else {
          message.clear();
          //console.log(json);
          app.config.globalProperties.$message({
            message: '更新に成功しました.',
            type: 'success'
          });
        }
      })
      .catch(error => console.error(error))
    }
    const deleteImage = () => {
      isShowConf.value = false
      const json = { path: delImg.path, csrf: props.user.csrf }
      fetch(api_path + 'ajax/unlink.php', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(json)
      })
      .then(response => response.json())
      .then(json => {
        //console.log(json);
        if(json['result'] == 'failure') {
          message.msg = json['error']
          message.err = true
          app.config.globalProperties.$message.error('削除できませんでした。')
        }else {
          message.clear();
          app.config.globalProperties.$message({
            message: '削除しました.',
            type: 'success'
          })
          getFiles()
        }
      })
      .catch(error => console.error(error))
    }
    const getHist = () => {
      loading.value = true
      fetch(api_path + 'ajax/orderhist.php?order_id=' + route.query.id, {
        method: 'GET',
        headers: {'Content-Type': 'application/json'}
      })
      .then(response => response.json())
      .then(json => {
        //console.log(json);
        if(json['result'] == 'failure') {
          if(json['err_code'] == 9) {
            context.emit('login', new clsUser())
          }
          throw new Error(json.error)
        }
        message.clear();
        Object.assign(order_info, json[0])
      })
      .catch(error => {
        console.error(error)
        message.msg = error.message
        message.err = true;
      })
      fetch(api_path + 'ajax/histdetail.php?order_id=' + route.query.id, {
        method: 'GET',
        headers: {'Content-Type': 'application/json'}
      })
      .then(response => response.json())
      .then(json => {
        //console.log(json);
        if(json['result'] == 'failure') {
          if(json['err_code'] == 9) {
            context.emit('login', new clsUser())
          }
          throw new Error(json.error)
        }
        message.clear();
        Object.assign(area_list, json)
      })
      .catch(error => {
        console.error(error)
        message.msg = error.message
        message.err = true;
      })
      .finally(() => {
        loading.value = false
      })
    }
    const getFiles = () => {
      fetch(api_path + 'ajax/getFileList.php?order_id=' + route.query.id, {
        method: 'GET',
        headers: {'Content-Type': 'application/json'}
      })
      .then(response => response.json())
      .then(json => {
        //console.log(json);
        if(json['result'] == 'failure') {
          if(json['err_code'] == 9) {
            context.emit('login', new clsUser());
          }
          throw new Error(json.error)
        }
        message.clear();
        if(json.files.length > 0) {
          const srcList2 = json.files.map((x:string) => `./upload/${route.query.id}/` + x.split("/").reverse()[0] + '?d=' + Math.random())
          srcList.splice(0)
          Object.assign(srcList, srcList2)
          url.value = srcList[0]
        }else {
          Object.assign(srcList, [])
          url.value = ''
        }
        // ファイル名決定
        let file_name = ''
        if(srcList.length < 1) {
          file_name = 'SideA'
        }else if(srcList.length < 2) {
          file_name = srcList[0].split("/").reverse()[0]
          if(file_name.split('.')[0] == 'SideA') {
            file_name = 'SideB'
          }else {
            file_name = 'SideA'
          }
        }
        if(route.query.id) {
          if(!Array.isArray(route.query.id)) {
            imgOptions.order_id = route.query.id
          }
        }
        imgOptions.file_name = file_name
      })
      .catch(error => {
        console.error(error)
        message.msg = error.message
        message.err = true;
      })
      .finally(() => {
        loading.value = false
      })
    }
    getHist()
    getFiles()

    return {
      message,
      loading,
      dialogVisible,
      isShowConf,
      url,
      srcList,
      imgOptions,
      order_info,
      area_list,
      distribute_way,
      uplDialog,
      updFeedback,
      deleteImage,
      back,
      beforeAvatarUpload,
      handleAvatarSuccess,
      handleDelete,
      uploader,
      handleImgHover,
      handleImgLeave,
      imgHover,
      delImg
    }
  }
})
</script>

<style scoped>
#hist {
  height: calc(100% - 69px);
  background-color: #ecf0f5;
  position: relative;
  overflow: auto;
}
#hist .el-header {
  padding-top: 30px;
  color: #6f6f6f;
  font-size: larger;
  text-align: center;
}
#hist .el-footer {
  text-align: right;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
}
.el-upload-list--picture-card .el-upload-list__item span.overray {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #29292999;
    width: 100%;
    height: 100%;
    cursor: pointer;
}
.el-upload-list--picture-card .el-upload-list__item span.overray .el-icon-delete {
    top: 45%;
    position: absolute;
    left: 47%;
    color: white;
}
</style>